import type { BaseThemePrepared } from '@archipro-design/aria';
import { boxClassName } from '@archipro-design/aria';
import { tileOverlayClassName } from '@archipro-design/aria';
import {
    archizeenTileClassName,
    avatarClassName,
    captionClassName,
    fileTileClassName,
    fileTileSlotClassNames,
    flexClassName,
    productTileClassName,
    productTileSlotClassNames,
    professionalTileClassName,
    professionalTileSlotClassNames,
    projectTileClassName,
    pxArrayToRem,
    pxToRem,
    SubheaderClassName,
    tileImageClassName,
    tileImageSlotClassNames,
} from '@archipro-design/aria';
import {
    TILE_WIDTH_DESKTOP,
    TILE_HEIGHT_DESKTOP,
    PROFESSIONAL_TILE_HEIGHT_DESKTOP,
    PROJECT_TILE_HEIGHT_DESKTOP,
} from '~/modules/design-board/config';

export const PinTilesDesktop = (theme: BaseThemePrepared) => ({
    [`& .${productTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: '100%',
            height: 'auto',
            aspectRatio: TILE_WIDTH_DESKTOP / TILE_HEIGHT_DESKTOP,
        },
        [`& .${productTileSlotClassNames.content}`]: {
            padding: pxArrayToRem([0, 6, 0, 1]),
            [`& .${productTileSlotClassNames.product}`]: {
                width: 'inherit',
                whiteSpace: 'unset',
                display: 'unset',
                textOverflow: 'unset',
            },
            [`& .${productTileSlotClassNames.professional}`]: {
                margin: pxArrayToRem([-3, 0, 13, 0]),
            },
            [`& .${productTileSlotClassNames.price}`]: {},
        },

        [`& .${productTileSlotClassNames.variants}`]: {
            margin: pxArrayToRem([16, 0, 0, 1]),
            [`& .${productTileSlotClassNames.variant}`]: {
                height: pxToRem(8.63),
                width: pxToRem(8.63),
                marginRight: pxToRem(3.94),
                ':first-child': {
                    marginLeft: pxToRem(1),
                },
            },
            [`& .${captionClassName}`]: {},
        },
    },

    [`& .${projectTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: '100%',
            height: 'auto',
            aspectRatio: TILE_WIDTH_DESKTOP / PROJECT_TILE_HEIGHT_DESKTOP,
        },

        [`& .${tileOverlayClassName}`]: {
            padding: 0,
        },
    },

    [`& .${professionalTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: '100%',
            height: 'auto',
            aspectRatio: TILE_WIDTH_DESKTOP / PROFESSIONAL_TILE_HEIGHT_DESKTOP,
        },

        [`& .${professionalTileSlotClassNames.content}`]: {
            [`& .${avatarClassName}`]: {
                height: pxToRem(75),
                width: pxToRem(75),
                margin: pxArrayToRem([-54, 0, 18, -3]),
            },

            [`& .${professionalTileSlotClassNames.textWrap}`]: {
                marginLeft: pxToRem(-4),
            },
        },
    },

    [`& a.${archizeenTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: '100%',
            height: 'auto',
            aspectRatio: TILE_WIDTH_DESKTOP / TILE_HEIGHT_DESKTOP,
            marginBottom: pxToRem(27),

            [`& .${tileImageSlotClassNames.imageContainer}`]: {
                width: pxToRem(TILE_WIDTH_DESKTOP),
                maxHeight: pxToRem(TILE_HEIGHT_DESKTOP),
                aspectRatio: TILE_WIDTH_DESKTOP / TILE_HEIGHT_DESKTOP,
            },
        },
        [`& > .${flexClassName}`]: {
            paddingLeft: pxToRem(1),
            [`& .${SubheaderClassName}`]: {
                fontSize: pxToRem(18),
                ...theme.siteVariables.textStyles.Article.Roman55,
                letterSpacing: theme.siteVariables.letterSpacingSmall,
                marginBottom: pxToRem(18),
                paddingRight: pxToRem(12),
            },
            [`& > .${flexClassName}`]: {
                [`& .${captionClassName}`]: {
                    fontSize: pxToRem(8.6),
                    letterSpacing: '0.02em',
                },
                [`& > .${captionClassName}`]: {
                    fontWeight: '500',
                    marginBottom: 0,
                },
                '& span': {
                    marginRight: pxToRem(2),
                },
            },
        },
    },

    [`& .${fileTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: '100%',
            height: 'auto',
            aspectRatio: TILE_WIDTH_DESKTOP / TILE_HEIGHT_DESKTOP,
        },
        '&.upload-file-pin': {
            [`& .${fileTileSlotClassNames.extensionText}`]: {
                margin: pxArrayToRem([1, 0, 0, 3]),
            },
            [`& .${tileImageSlotClassNames.imageContainer}`]: {
                '& img': {
                    marginTop: pxToRem(1),
                    minWidth: pxToRem(288),
                },
            },
            [`& .${fileTileSlotClassNames.contentWrap}`]: {
                margin: pxArrayToRem([27, 0, 0, 1]),
            },
        },
        [`& .${fileTileSlotClassNames.contentWrap}`]: {
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },

    '& .pin-tile': {
        width: '100%',
        [`& .${boxClassName}`]: {
            width: '100%',
        },

        '& .ui-tileOverlay__topActions': {
            pointerEvents: 'all',
            width: '100%',
        },
        '& .ui-tileOverlay': {
            alignItems: 'flex-start',
            width: '100%',
        },
    },
});
